import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9209d4de"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9209d4de')) {
      api.createRecord('9209d4de', component.options)
    } else {
      api.reload('9209d4de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9209d4de", function () {
      api.rerender('9209d4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/sale/inventory/index.vue"
export default component.exports